import { createMuiTheme } from "@material-ui/core/styles"

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#1d59b2",
    },
    secondary: {
      main: "#6cc04a",
    },
    tertiary: {
      main: "#FF8C00",
    },
  },
})

export default theme
